export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构名称',
            minWidth: 200
        },
        {
            prop: 'carNo',
            label: '报价个数',
            minWidth: 100
        },
        {
            prop: 'carType',
            label: '报价应交(元)',
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '出单个数',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '出单应交(元)',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'contractFee',
            label: '手续费(元)',
            minWidth: 100,
        },
        {
            prop: 'cusRebate',
            label: '净费(元)',
            minWidth: 100,
        },
        {
            prop: 'cusFee',
            label: '实收金额(元)',
            minWidth: 100,
        },
        {
            prop: 'customerRebate',
            label: '实收差额(元)',
            minWidth: 100,
        }

    ]
}

export default {}